import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, CrownIcon, ChevronDownIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Gallery',
    href: '/gallery'
  }, {
    name: 'Contact',
    href: '/#contact'
  }];
  const servicesLinks = [{
    name: 'Knotless Braids',
    href: '/services#knotless'
  }, {
    name: 'Box Braids',
    href: '/services#box'
  }, {
    name: 'Cornrows',
    href: '/services#cornrows'
  }, {
    name: 'Goddess Braids',
    href: '/services#goddess'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-cream shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-305">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-306">
        <div className="flex justify-between items-center" data-id="element-307">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group z-50" data-id="element-308">
            <CrownIcon className="w-8 h-8 text-brand-gold" data-id="element-309" />
            <div className="flex flex-col" data-id="element-310">
              <span className="font-display italic text-4xl lowercase tracking-wider text-cream leading-none" data-id="element-311">
                rozii
              </span>
              <span className="font-body text-[0.6rem] uppercase tracking-[0.2em] text-cream/70 font-bold mt-1" data-id="element-312">
                African Hair Braiding
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-313">
            <Link to="/" className={`text-sm uppercase tracking-widest font-medium transition-colors hover:text-brand-gold ${isScrolled ? 'text-near-black' : 'text-cream'}`} data-id="element-314">
              Home
            </Link>

            <Link to="/services" className={`text-sm uppercase tracking-widest font-medium transition-colors hover:text-brand-gold ${isScrolled ? 'text-near-black' : 'text-cream'}`} data-id="element-315">
              Services
            </Link>

            <Link to="/about" className={`text-sm uppercase tracking-widest font-medium transition-colors hover:text-brand-gold ${isScrolled ? 'text-near-black' : 'text-cream'}`} data-id="element-316">
              About
            </Link>
            <Link to="/gallery" className={`text-sm uppercase tracking-widest font-medium transition-colors hover:text-brand-gold ${isScrolled ? 'text-near-black' : 'text-cream'}`} data-id="element-317">
              Gallery
            </Link>
            <Link to="/contact" className={`text-sm uppercase tracking-widest font-medium transition-colors hover:text-brand-gold ${isScrolled ? 'text-near-black' : 'text-cream'}`} data-id="element-318">
              Contact
            </Link>

            <a href="tel:2409217857" className="px-6 py-2.5 rounded-full bg-brand-gold text-cream hover:bg-near-black text-sm uppercase tracking-widest font-bold transition-all flex items-center gap-2 shadow-md" data-id="element-319">
              Call to Book <span className="text-lg leading-none" data-id="element-320">→</span>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 z-50 text-warm-brown" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-321">
            {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-322" /> : <MenuIcon className="h-6 w-6" data-id="element-323" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-324">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} className="absolute top-full left-0 right-0 bg-cream shadow-xl border-t border-warm-brown/10 lg:hidden overflow-hidden" data-id="element-325">
            <div className="flex flex-col px-6 py-8 space-y-6" data-id="element-326">
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="text-xl font-display italic text-warm-brown hover:text-brand-gold transition-colors" data-id="element-327">
                Home
              </Link>
              <Link to="/services" onClick={() => setIsMobileMenuOpen(false)} className="text-xl font-display italic text-warm-brown hover:text-brand-gold transition-colors" data-id="element-328">
                Services
              </Link>
              <Link to="/about" onClick={() => setIsMobileMenuOpen(false)} className="text-xl font-display italic text-warm-brown hover:text-brand-gold transition-colors" data-id="element-329">
                About
              </Link>
              <Link to="/gallery" onClick={() => setIsMobileMenuOpen(false)} className="text-xl font-display italic text-warm-brown hover:text-brand-gold transition-colors" data-id="element-330">
                Gallery
              </Link>
              <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)} className="text-xl font-display italic text-warm-brown hover:text-brand-gold transition-colors" data-id="element-331">
                Contact
              </Link>
              <div className="pt-4" data-id="element-332">
                <a href="tel:2409217857" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center justify-center gap-2 w-full text-center px-6 py-4 rounded-full bg-brand-gold text-cream font-bold uppercase tracking-widest text-sm hover:bg-near-black transition-colors shadow-md" data-id="element-333">
                  Call to Book <span data-id="element-334">→</span>
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}